export default __webpack_public_path__ + "static/media/ambasadorp2big.7a3954d9.jpg";